import { useGetInfluencerQuery } from '../../../generated/graphql';
import { useUserStore } from '../stores/user.store';
import { _noop } from '../helpers/general';

export const useInfluencer = (params?: { creatorId?: number }) => {
  const { user } = useUserStore();
  const influencerId = params?.creatorId ?? user?.influencerId;

  const influencerQuery = useGetInfluencerQuery({
    variables: { id: Number(influencerId) },
    skip: !influencerId,
  });

  if (influencerQuery.loading) {
    return {
      isLoading: true,
      influencer: null,
      links: null,
      refetchInfluencer: _noop,
    };
  }

  return {
    error: influencerQuery.error,
    isLoading: influencerQuery.loading,
    influencer: influencerQuery.data?.creator ?? null,
    refetchInfluencer: influencerQuery.refetch,
  };
};
